import { FC } from "react";
import { Box, Stack, SystemProps, Text } from "@storyofams/react-ui";
import { ProductOption } from "~lib/shopify/sdk";
import { SingleVariant } from "../SingleVariant";

interface SingleOptionProps extends SystemProps {
  autoDiscount: string | null;
  refillVariants: any[];
  regularVariants: any[];
  options: Pick<ProductOption, "name" | "values">[];
  mostPopularVariant: string;
}

export const SingleOption: FC<SingleOptionProps> = ({
  regularVariants,
  refillVariants,
  autoDiscount,
  mostPopularVariant,
  options,
}) => {
  return (
    <Box>
      <Text color={"#767473"} fontSize={"14px"} mb={1}>
        {options[0].name}
      </Text>
      <Stack flexDirection={"column"} space={1}>
        {regularVariants.map(([key, value], i) => (
          <SingleVariant
            key={key}
            option={value[0]}
            autoDiscount={autoDiscount}
            mostPopularVariant={mostPopularVariant}
          />
        ))}
      </Stack>
      {!!refillVariants.length && (
        <>
          <Text mt={2} color={"#767473"} fontSize={"14px"} mb={1}>
            {"Refill / Bulk"}
          </Text>
          <Stack flexDirection={"column"} space={1}>
            {refillVariants.map(([key, value], i) => (
              <SingleVariant
                key={key}
                option={value[0]}
                autoDiscount={autoDiscount}
                mostPopularVariant={mostPopularVariant}
              />
            ))}
          </Stack>
        </>
      )}
    </Box>
  );
};
